import React from 'react'
import { PageTitleContainer, PageTitleText } from './PageLayout.styles'

export const PageTitle = ({
  title,
  noBorder,
  rightContent,
}: {
  title: string
  noBorder?: boolean
  rightContent?: React.ReactNode
}): JSX.Element => {
  return (
    <PageTitleContainer $noBorder={noBorder}>
      <PageTitleText>{title}</PageTitleText>
      {rightContent}
    </PageTitleContainer>
  )
}
